import React, { useContext } from 'react';
export var a11yContext = /*#__PURE__*/React.createContext({});
export default function useA11yProps() {
  return useContext(a11yContext);
}
//# sourceMappingURL=useA11yProps.js.map